enum Genders {
  NotSet = 0,
  Femenino = 1,
  Masculino = 2,
  NonBinary = 3,
}

export default Genders
